import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import {bbbeeModule} from "../../../Component/Common/Constants/routes";
import {ScorecardLicenseMain} from "./ScorecardLicenseMain";
import {MDBox} from "../../../Component/Common/Components/MDBox";
import {MDTypography} from "../../../Component/Common/Components/MDTypography";

export const VerificationScorecardBasePage = () => {
    const path = `${bbbeeModule.bee}/${bbbeeModule.verificationScorecards}`;
    const routes = [
      `/${path}/Accepted`,
      `/${path}/Submitted`,
  ]

  const routeMatch = useRouteMatch(routes);
  const currentTab = routeMatch?.path;

  return (
      <>
        <MDBox style={{ padding: "10px" }}>
          <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
            Verification Scorecards
          </MDTypography>
            <MDTypography variant="body2" fontWeight="bold">The following scorecards have been submitted to a verification agency</MDTypography>
        </MDBox>
        <Grid container>
          <Grid item xs={12}>
            <Tabs value={currentTab} aria-label="Tabs" centered>
              <Tab label="Accepted" value={routes[0]} to={routes[0]} component={Link} />
              <Tab label="Submitted" value={routes[1]} to={routes[1]} component={Link} />
            </Tabs>
          </Grid>
          <Grid item xs={12} mt={1}>
            <Switch>
              <Route path={routes[0]}>
                <ScorecardLicenseMain isSharedForVerification={true} isLocked={false}/>
              </Route>
              <Route path={routes[1]}>
                <ScorecardLicenseMain isSharedForVerification={true} isLocked={true}/>
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </>);
}